module.exports = __webpack_public_path__ + "7e5e3b85d1a61b27c494df938b6288c2.pdf";